module.exports = __webpack_public_path__ + "img/yoga.111414d3.png";